import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'


window.addEventListener('load', function() {
    // 首页轮播
    var banner = new Swiper('.banner .swiper-container', {
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        speed:1000,
        loop:true,//必须
        // 左右按钮
        navigation: {
            nextEl: ".banner .swiper-button-next",
            prevEl: ".banner .swiper-button-prev",
        },
        // 只启用一个 pagination（进度条）
        pagination: {
            el: ".banner .swiper-pagination",
            type: "progressbar",
        },
    }); 

    var thumbSwiper = new Swiper(".section4 .swiper-thumb", {
        loop:true,
        loopedSlides: 3,
        centeredSlides: true,
        direction : 'vertical',
        spaceBetween: "3.3%",
        slidesPerView: 3,
        slideToClickedSlide: true,
        
    });
    var mainSwiper = new Swiper(".section4 .swiper-text", {
        loop:true,
	    loopedSlides: 3,
        effect: "fade",
        navigation: {
            nextEl: ".section4 .swiper-button-next",
            prevEl: ".section4 .swiper-button-prev",
        },
    });
    thumbSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = thumbSwiper;
})
